module.exports = __webpack_public_path__ + "img/home-1.419ce8b0.jpg";